/**
 * Build Mixpanel purchase props from the CDS Frequent Passenger opt-in checkbox state
 * persisted in purchase.meta.frequent_passenger_enrollment.
 * @param {object} purchase - Purchase object (as passed to purchase-funnel trackers).
 * @returns {object} `{ cds_frequent_passenger_opt_in }` when set, otherwise empty object.
 */
// eslint-disable-next-line import/prefer-default-export
export function serializeCdsFrequentPassengerOptInProps(purchase) {
  const optedIn = purchase?.meta?.frequent_passenger_enrollment;

  if (optedIn === 'true' || optedIn === 'false') {
    return { cds_frequent_passenger_opt_in: optedIn === 'true' };
  }

  return {};
}
